import { createFileRoute } from '@tanstack/react-router';

import { ComparePage } from '@/features/compare/compare-page';
import { compareSearchSchema } from '@/features/compare/compare-params';

export const Route = createFileRoute('/compare')({
	validateSearch: compareSearchSchema,
	component: ComparePage,
});
